/**
 * Root of application state
 *
 * When a combination of sub module state is required the brain is the place to add it.
 *
 * @type Object
 */
import { REGION_EMEA, REGIONS } from "@/service/Constants";
import { setHeader, http } from "@/services/http";
import ui from "@/store/modules/ui";
import auth from "@/store/modules/auth";

const state = {
  region: REGION_EMEA,
  defaultRegion: REGIONS[REGION_EMEA].label,
  distanceUnit: REGIONS[REGION_EMEA].distanceUnit,
  distanceUnitMultiLength: REGIONS[REGION_EMEA].distanceUnit,
  maintenanceMode: false,
  allRegions: REGIONS,
};

const getters = {};

const mutations = {
  maintenanceMode(state, value) {
    state.maintenanceMode = value;
    setHeader("Maintenance-Mode", value);
  },
  setRegion(state, value) {
    if (value) {
      state.region = value;
    } else {
      console.log("No valid region found, choosing EMEA");
      state.region = REGION_EMEA;
    }
    state.distanceUnit = REGIONS[state.region].distanceUnit;
    state.distanceUnitMultiLength = REGIONS[state.region].distanceUnit;
  },
  setDefaultRegion(state, value) {
    state.defaultRegion = value;
  },
  setDistanceUnitMultiLength(state, value) {
    state.distanceUnitMultiLength = value;
  },
};

const actions = {
  switchRegion: ({ commit, dispatch }, { region, clearSolution }) => {
    return new Promise((resolve) => {
      if (region === undefined || !region) {
        region = "emea";
        console.log("Unable to switch region, defaulting back to " + region);
      }

      // Mark playground as dirty, so reload is forced
      dispatch("brain/global/forceReload", null, { root: true });

      if (clearSolution) {
        dispatch("brain/solutions/clearSolutions", null, { root: true });
        commit("brain/modules/setModule", null, { root: true });
        commit("brain/modules/setIncompatibleModule", null, { root: true });
        commit("brain/drivers/setDriver", null, { root: true });
      }
      commit("setRegion", region);
      setHeader("Region", region.toUpperCase());
      commit("brain/ui/clearSavedColumnVisibility", null, { root: true });
      commit("brain/modules/setPinnedModules", [], { root: true });
      commit("brain/drivers/setPinnedDrivers", [], { root: true });
      commit("brain/modules/setComparedModules", [], { root: true });
      commit("brain/drivers/setComparedDrivers", [], { root: true });

      try {
        localStorage.setItem("region", region);
      } catch (e) {
        // Local storage not available
      }

      dispatch("brain/drivers/setNewFilterSet", null, { root: true }).then(
        () => {
          resolve();
        }
      );
    });
  },
  async setDefaultRegion({ commit }, region) {
    commit("setDefaultRegion", region);
    return await http({
      method: "post",
      url: `/api/v2/users/profile/settings`,
      data: {
        region: region,
      },
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    ui,
    auth,
  },
};
